import React from 'react';
import { useHistory } from 'react-router-dom';
import { useRootStore } from '../../../stores/BridgeProvider';
import { FlexDiv } from '../../styles/styles';
import PaymentTypeForm from '../PaymentTypeForm';

const NewPaymentType = () => {
  const history = useHistory();
  const { authStore } = useRootStore();

  return (
    <FlexDiv>
      <PaymentTypeForm
        onSubmit={async values => {
          const { TranType, PaymentTypeName, AccountId, SortOrder } = values;
          try {
            await authStore.request.post(
              `${process.env.REACT_APP_API}/api/payment-type`,
              {
                TranType,
                PaymentTypeName,
                AccountId,
                SortOrder,
              },
            );
            history.push('/payment-types');
          } catch (e) {
            console.error(e);
          }
        }}
      />
    </FlexDiv>
  );
};

export default NewPaymentType;
